import { isMac, isWindows } from 'utils/platform';

export const allowLinkRedirect = (event: React.MouseEvent): boolean => {
  const { platform } = window.navigator;

  return (event.ctrlKey && isWindows(platform)) || (event.metaKey && isMac(platform));
};
